"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHistoricalRelayAdaptContractAddress = exports.networkForChain = void 0;
const network_config_1 = require("../models/network-config");
const networkForChain = (chain) => {
    return Object.values(network_config_1.NETWORK_CONFIG).find(network => network.chain.type === chain.type && network.chain.id === chain.id);
};
exports.networkForChain = networkForChain;
const isHistoricalRelayAdaptContractAddress = (networkName, address) => {
    const network = network_config_1.NETWORK_CONFIG[networkName];
    return (network.relayAdaptHistory.find(historicalAddress => {
        return historicalAddress.toLowerCase() === address.toLowerCase();
    }) != null);
};
exports.isHistoricalRelayAdaptContractAddress = isHistoricalRelayAdaptContractAddress;
